<template>
  <v-row justify="center" no-gutters>
    <v-col cols="11">
      <v-row v-if="value && !!value.items" class="my-3" dense>
        <v-col v-for="card in value.items" :key="card.title" cols="12">
          <v-card class="transparent rounded-lg overflow-hidden" flat>
            <v-img
              :src="getImage(card)"
              class="white--text hoverCard align-end position-relative"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="450px"
            >
              <v-card
                class="d-flex flex-column transparent align-center go-end"
                dark
                flat
                height="100%"
              >
                <v-img
                  :src="getImage(card)"
                  aspect-ratio="1"
                  class="mx-auto rounded-pill mt-4"
                  max-height="120"
                  width="120"
                />

                <v-card-title v-text="card.full_name" />
                <v-card-subtitle v-text="card.position" />

                <v-spacer />

                <v-card-subtitle
                  v-if="card.phone"
                  class="text-center d-flex flex-column"
                >
                  <div class="my-auto contentSection">
                    <v-btn class="p-2 py-4" color="primary" rounded small>
                      <span class="font-weight-bold ml-2" v-text="card.phone" />
                      <v-icon>mdi-phone</v-icon>
                    </v-btn>
                    <p
                      class="mt-5 font-weight-bold text-white overflow-y-auto custom-scrollbar"
                      style="max-height: 105px"
                      v-text="card.description"
                    />
                  </div>
                </v-card-subtitle>
              </v-card>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "teamUi",

  props: {
    value: [Object, Array],
  },

  methods: {
    getImage(c) {
      return !!c.image[0].images && !!c.image[0].images.length
        ? c.image[0].images[0].url
        : false;
    },
  },
};
</script>

<style scoped>
.go-end > * {
  position: relative;
  z-index: 2;
}

.go-end:before {
  position: absolute;
  z-index: 0;
  inset: 0;
  width: 100%;
  height: 100%;
  content: "";
  -webkit-filter: blur(3px); /* Safari 6.0 - 9.0 */
  filter: blur(3px);
  color: #f3f5f9;
  background: rgba(0, 0, 0, 0.4);
  transition: 0.5s ease-in;
}

.v-image >>> .v-responsive__content {
  height: 100%;
}
</style>
